var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Favourite = _interopRequireDefault(require("../Favourites/Favourite"));

var _Basic = require("../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _Button = _interopRequireDefault(require("../Basic/Button"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/FavouritesExpandable/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FavouritesExpandable = function (_React$Component) {
  (0, _inherits2.default)(FavouritesExpandable, _React$Component);

  var _super = _createSuper(FavouritesExpandable);

  function FavouritesExpandable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FavouritesExpandable);
    _this = _super.call(this, props);

    _this.nextFavorite = function () {
      return _this.setState(function (prevState) {
        return {
          startIndex: prevState.startIndex + 1
        };
      });
    };

    _this.prevFavorite = function () {
      _this.setState(function (prevState) {
        return {
          startIndex: prevState.startIndex - 1
        };
      });
    };

    _this.state = {
      startIndex: 0
    };
    return _this;
  }

  (0, _createClass2.default)(FavouritesExpandable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          favourites = _this$props.favourites,
          onPress = _this$props.onPress,
          onItemPress = _this$props.onItemPress,
          onItemRemove = _this$props.onItemRemove,
          isMobile = _this$props.isMobile,
          createHref = _this$props.createHref,
          NavWrapper = _this$props.NavWrapper;
      var startIndex = this.state.startIndex;
      var numOfVisibleFavs = Math.floor((this.props.contentWidth - 60 - 66) / 72);
      return _react.default.createElement(_react.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 13
        }
      }, !isMobile ? _react.default.createElement(_Basic.Row, {
        overflow: "hidden",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 21
        }
      }, _react.default.createElement(_Touchable.default, {
        px: 2,
        onPress: onPress,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 25
        }
      }, _react.default.createElement(_Basic.View, {
        style: {
          width: 48,
          height: 48,
          borderRadius: 48 / 2,
          borderWidth: 1,
          borderColor: '#dddddd',
          borderStyle: 'solid'
        },
        center: true,
        isFlex: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 29
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        size: "custom",
        fontSize: 18,
        lineHeight: "48px",
        name: "plus",
        color: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 33
        }
      }))), startIndex > 0 ? _react.default.createElement(_Button.default, {
        onPress: this.prevFavorite,
        bold: true,
        customStyle: true,
        textColor: "font.main",
        mt: "12px",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.View, {
        textAlign: "center",
        rotate: 180,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 33
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        name: "arrow-front",
        size: "custom",
        fontSize: "28px",
        lineHeight: "28px",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 37
        }
      }))) : null, _react.default.createElement(_Basic.Row, {
        ml: favourites && favourites.length <= numOfVisibleFavs || startIndex > 0 ? 0 : '28px',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96,
          columnNumber: 25
        }
      }, favourites ? favourites.map(function (item, index) {
        if (index >= startIndex && index < startIndex + numOfVisibleFavs) {
          return _react.default.createElement(_Favourite.default, {
            key: item.id + "_" + (item.name || item.nickName || item.lastName),
            icon: item.imageUrl,
            title: item.name || item.nickName || item.lastName,
            onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onItemPress, item),
            onRemove: function onRemove() {
              return onItemRemove(item);
            },
            imageType: item.type,
            mb: 3,
            href: (0, _PropsHelper.executeFunctionOrUndefined)(createHref, item),
            NavWrapper: NavWrapper,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 111,
              columnNumber: 47
            }
          });
        }

        return null;
      }) : null), favourites && startIndex + numOfVisibleFavs < favourites.length ? _react.default.createElement(_Button.default, {
        onPress: this.nextFavorite,
        bold: true,
        customStyle: true,
        textColor: "font.main",
        mt: "12px",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 139,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.View, {
        textAlign: "center",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146,
          columnNumber: 33
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        name: "arrow-front",
        size: "custom",
        fontSize: "28px",
        lineHeight: "28px",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 147,
          columnNumber: 37
        }
      }))) : null) : _react.default.createElement(_Basic.View, {
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Row, {
        overflow: "scroll",
        iosOverflow: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 25
        }
      }, _react.default.createElement(_Touchable.default, {
        px: 2,
        onPress: onPress,
        ml: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.View, {
        style: {
          width: 48,
          height: 48,
          borderRadius: 48 / 2,
          borderWidth: 1,
          borderColor: '#dddddd',
          borderStyle: 'solid'
        },
        center: true,
        isFlex: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 33
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        size: "custom",
        fontSize: 18,
        lineHeight: "48px",
        name: "plus",
        color: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 37
        }
      }))), favourites ? favourites.map(function (item, index) {
        return _react.default.createElement(_Favourite.default, {
          key: item.id + "_" + (item.name || item.nickName || item.lastName),
          icon: item.imageUrl,
          title: item.name || item.nickName || item.lastName,
          onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onItemPress, item),
          imageType: item.type,
          pr: index === favourites.length - 1 ? 4 : 0,
          href: (0, _PropsHelper.executeFunctionOrUndefined)(createHref, item),
          NavWrapper: NavWrapper,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 184,
            columnNumber: 39
          }
        });
      }) : null), _react.default.createElement(_Basic.View, {
        position: "absolute",
        height: "100%",
        width: 50,
        gradient: {
          direction: 'to left',
          start: 'white',
          end: 'rgba(255, 255, 255, 0)'
        },
        top: 0,
        right: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 202,
          columnNumber: 25
        }
      })));
    }
  }]);
  return FavouritesExpandable;
}(_react.default.Component);

exports.default = FavouritesExpandable;
FavouritesExpandable.propTypes = {
  favourites: _propTypes.default.arrayOf(Object).isRequired,
  isMobile: _propTypes.default.bool,
  onPress: _propTypes.default.func.isRequired,
  onItemPress: _propTypes.default.func.isRequired,
  onItemRemove: _propTypes.default.func.isRequired,
  contentWidth: _propTypes.default.number.isRequired,
  NavWrapper: _propTypes.default.func
};